module.exports = __webpack_public_path__ + "static/media/pottery-1283146_1280.2b208565.jpg";